<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <img :src="imageUrl" />
        <div style="display:flow-root">
          <app-row
            icon="hashtag"
            title="شناسه درخواست:"
            :value="item.Fserial"
            :hasImage="true"
          />
          <app-row
            icon="calendar-alt"
            title="تاريخ درخواست:"
            :value="item.DDate"
            :hasImage="true"
          />
        </div>
        <div style="padding: 15px">
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضیحات طلبه:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="content">
              <span v-html="item.StudentComment"></span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضيحات پذيرش:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="content">
              <span v-html="item.MarkazComment"></span>
            </v-col>
          </v-row>

          <v-row v-if="item.Removeable" class="ltr">
            <v-btn
              color="red white--text"
              class="register"
              rounded
              @click="$emit('removeRequest', item.Fserial)"
            >
              حذف درخواست
            </v-btn>
          </v-row>
          <div style="padding: 5px"></div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item"],
  computed: {
    imageUrl() {
      return "data:image/jpeg;base64," + this.item.Image;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
img {
  width: 100px;
  border-radius: 10px;
  height: 125px;
  float: left;
  margin: 15px;
}
</style>

